<template>
    <div>
        <div class="brand-font">
            <h4>
                品牌字体
                <span class="iconfont icon-shezhi-01 setup-btn" @click.stop="setLocalVisiableHandler" v-loading.fullscreen.lock="fullscreenLoading" v-if="loginInfo.current_team_role !== 4"></span>
            </h4>
            <ul>
                <li v-if="loginInfo.current_team_role !== 4">
                    <div class="logo-uploader" @click="editFontOpen('add')">
                        <i class="avatar-uploader-icon icon-Addto iconfont"></i>
                        <p>上传字体</p>
                    </div>
                </li>
                <li class="font-li">
                    <div class="font-title">标题</div>
                    <div class="font-name">
                        <p class="font-name-text">{{ fontT && fontT.name }}</p>
                        <span class="iconfont icon-More font-icon-more" @click.stop="checkedFont(1)" v-if="loginInfo.current_team_role !== 4"></span>
                    </div>
                    <div class="font-action" v-if="checkFontIndex === 1 && checkedStatus">
                        <p class="handle-block-p" @click.stop="editFontOpen('edit')">
                            修改
                        </p>
                    </div>
                </li>

                <li class="font-li">
                    <div class="font-title">正文</div>
                    <div class="font-name">
                        <p class="font-name-text">{{ fontB && fontB.name }}</p>
                        <span class="iconfont icon-More font-icon-more" @click.stop="checkedFont(2)" v-if="loginInfo.current_team_role !== 4"></span>
                    </div>
                    <div class="font-action" v-if="checkFontIndex === 2 && checkedStatus">
                        <p class="handle-block-p" @click.stop="editFontOpen('edit')">
                            修改
                        </p>
                    </div>
                </li>

                <li class="font-li" v-for="(item, index) in fontList" :key="item.attr ? item.attr : item.id">
                    <div class="font-title">
                        <img :src="item.view" :alt="item.name" />
                    </div>

                    <div class="font-name">
                        <p class="font-name-text">{{ item.name }}</p>
                        <span class="iconfont icon-More font-icon-more" @click.stop="checkedFont(index + 3)" v-if="loginInfo.current_team_role !== 4"></span>
                    </div>

                    <div class="font-action" v-show="checkFontIndex === index + 3 && checkedStatus">
                        <p class="handle-block-p" @click.stop="editFontOpen('edit')">
                            修改
                        </p>
                        <p class="handle-block-p" @click.stop="showRemoveDialog">删除</p>
                    </div>
                </li>
            </ul>
        </div>
        <el-dialog title="选择字体" :visible.sync="editFontDialogStatus" width="364px" height="382px" class="font-dialog" @close="close">
            <div class="font-dialog-con">
                <div class="selected-font-input" @click.stop="fontListStatus = true">
                    <img :src="selectedFontObj.view" class="selectedFontImage" width="200" height="28" />
                    <i class="el-icon-arrow-down"></i>
                </div>
                <!-- 团队身份为高于成员身份显示 -->
                <div class="upload-loclbtn" v-show="loginInfo.current_team_role < 4" @click="openUploadLocal">
                    <div class="upload-btnbox">
                        <span class="iconfont icon-weibiaoti-1-041"></span>上传本地字体
                    </div>
                </div>
                <div class="font-list" v-show="fontListStatus">
                    <!-- <ul class="font-list-ul"> -->
                    <el-scrollbar tag="ul" style="height: 100%; overflow-x: hidden">
                        <li v-for="item in fontOptions" :key="item.id" @click.stop="selectedFont(item)" :class="selectedFontObj.view === item.view ? 'active' : ''">
                            <img :src="item.view" width="200" height="28" />
                        </li>
                    </el-scrollbar>
                    <!-- </ul> -->
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="btn-wrap">
                    <!--class="cancel-btn"-->
                    <el-button @click.stop="fontClose">取消</el-button>
                    <!--class="confirm-btn"-->
                    <el-button type="primary" @click.stop="selectSystemConfirm">
                        确认
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 上传本地字体弹框 -->
        <el-dialog class="upload-localfont-dialog" title="上传品牌字体" :visible.sync="uploadLocalVisiable" :close-on-click-modal="false" center @close="stopUpload" :before-close="uploadbeforeclose" ref="uploadfontdialog" @open="openuploadtool">
            <div class="upload-localfont-title">
                <span>字体（{{ upload_finished }}/{{ upload_total }}）</span>
            </div>
            <!-- 错误提示 -->
            <el-alert :title="`有${upload_fail}个资源上传失败`" type="error" show-icon :closable="false" v-show="upload_fail > 0" class="errorinfo-alert">
            </el-alert>
            <!-- 上传按钮以及上传中的字体列表 -->

            <ul class="upload-list-box">
                <li v-show="showuploadtool">
                    <div id="upload-section">
                        <file-upload class="upload-component" ref="upload" v-model="showFileList" :input-id="name" :post-action="fontaction" :accept="accept" :multiple="fontselectmultiple" :add-index="addIndex" @input-filter="inputFilter" @input-file="inputFile" @exceed="exceed" :headers="headers" :data="uploaddata" :thread="2" :maximum="maximum">
                            <i class="el-icon-plus"></i>
                        </file-upload>
                    </div>
                </li>

                <li v-for="(file, i) in showFileList" :key="i" class="fileitem">
                    <!-- 等待上传  可展示删除按钮 -->
                    <template v-if="file.upload_step == 1">
                        <div class="state-box state-box-border" @mouseenter.prevent="fontmouseover(file, i)" @mouseleave.prevent="fontmouseout(file, i)">
                            <img src="@/assets/image/fontdefault.png" alt="" />
                            <div :class="{
                  'upload-listitem-actions': file.maskshow,
                  'upload-listitem-actions-tip': file.maskshow,
                }">
                                <img src="@/assets/image/upload_error.png" alt="" class="upload-delete-icon" @click.prevent="
                    $refs.upload.remove(file);
                    upload_fail--;
                  " v-if="file.maskshow" />
                            </div>
                        </div>
                    </template>

                    <!-- 上传中  展示进度条 -->
                    <template v-if="file.upload_step == 2">
                        <div class="state-box state-box-border" @mouseenter="fontmouseover(file, i)" @mouseleave="fontmouseout(file, i)">
                            <img src="@/assets/image/fontdefault.png" alt="" />
                            <div class="upload-listitem-actions">
                                <el-progress :percentage="file.progress" :color="progresscolor" stroke-width="3" :show-text="false"></el-progress>
                            </div>
                        </div>
                    </template>

                    <!-- 上传结束  -->
                    <template v-if="file.upload_step == 3">
                        <!-- 实际接口请求成功展示状态 -->
                        <template v-if="file.upload_status == 4">
                            <div class="state-box state-box-border" @mouseenter="fontmouseover(file, i)" @mouseleave="fontmouseout(file, i)">
                                <img class="img_path" :src="file.response.data.img_path" alt="" />
                                <div class="upload-listitem-actions upload-listitem-actions-tip" v-if="file.maskshow == true">
                                    <img src="@/assets/image/upload_error.png" alt="" class="upload-delete-icon" @click.prevent="
                      removeLocalFont(file);
                      upload_fail--;
                    " />
                                </div>
                            </div>
                            <!-- 展示字体名字 -->
                            <div class="upload-lsititem-title">{{ file.name }}</div>
                        </template>

                        <template v-if="file.upload_status == 3 || file.upload_status == 5">
                            <div class="state-box state-box-border" @mouseenter="fontmouseover(file, i)" @mouseleave="fontmouseout(file, i)">
                                <img src="@/assets/image/fontdefault.png" alt="" />
                                <div class="upload-listitem-actions upload-listitem-actions-tip">
                                    <template v-if="file.maskshow == false">
                                        <img src="@/assets/image/upload_error.png" alt="" class="upload-fail-icon" />
                                        <div class="upload-fail-tiptext">上传失败</div>
                                        <div class="upload-fail-tiptext">
                                            {{ file.response.error || "接口出错" }}
                                        </div>
                                    </template>

                                    <template v-if="file.maskshow == true">
                                        <el-button class="tryagain-btn" @click.prevent="
                        $refs.upload.update(file, {
                          active: true,
                          error: '',
                          success: false,
                          response: {},
                          progress: '0.00',
                          upload_step: 2,
                          upload_status: 2,
                        });
                        upload_fail--;
                      ">重试</el-button>
                                        <img src="@/assets/image/upload_error.png" alt="" class="upload-delete-icon" @click.prevent="
                        $refs.upload.remove(file);
                        upload_fail--;
                      " />
                                    </template>
                                </div>
                            </div>
                        </template>
                    </template>
                </li>
            </ul>

            <div class="btn-wrap" slot="footer">
                <!--class="cancel-btn" -->
                <el-button @click="uploadLocalcancle">取消</el-button>
                <!--'confirm-btn': true, -->
                <el-button type="primary" :class="{ 'is-disabled': !uploaded }" @click="uploadLocalconfirm" :disabled="!uploaded">
                    确认
                </el-button>
            </div>
        </el-dialog>

        <!-- 设置工作台是否显示品牌字体弹框 -->
        <set-font-dialog :checklist="checkList"></set-font-dialog>

        <remove-dialog :title="deleteTip" @remove="deleteFont" :confirmtext="'删 除'" />
        <!--过期弹出框-->
        <expireTeamDialog />

        <font-edit-dialog :title="editTipTile" @edit="editFont">
            <!-- 字体修改确认弹框 -->
        </font-edit-dialog>

        <upload-cancel :title="'取消后未成功的需要重新上传，是否取消？'" @confirm="stopUpload"></upload-cancel>
    </div>
</template>

<script>
import { Brand } from "@/config/axios/new_api";
import removeDialog from "@/components/dialog/removeDialog.vue";
import fontEditDialog from "@/components/dialog/fontEditDialog.vue";
import setFontDialog from "@/components/dialog/setFontDialog.vue";
import FileUpload from "isheji-upload-component/src";
import uploadCancel from "@/components/dialog/uploadCancel.vue";
import Vue from "vue";
// 使用方式
import ZMessage from "@/config/static/zmessage.js";
import tokenFunc from "@/config/static/token";
ZMessage.setConfig({ max: 5, isQueue: false, showNewest: true });

Vue.prototype.$zmessage = ZMessage;

export default {
    components: {
        removeDialog,
        FileUpload,
        fontEditDialog,
        setFontDialog,
        uploadCancel,
    },
    name: "fontTemplate",
    props: ["BrandInfo", "FontsInfo"],
    data() {
        return {
            fontOptions: [],
            checkFontIndex: 0,
            editFontDialogStatus: false,
            removeDialogStatus: false,
            fontEditDialogStatus: false,
            selectedFontObj: {},
            fontListStatus: false,
            checkedStatus: false,
            uploadLocalVisiable: false,
            setLocalVisiable: false,
            uploaderror: false,
            uploadCancelDialogStatus: false,
            checkList: ["1"],
            progresscolor: "#FFFFFF",
            showuploadtool: true,
            upload_finished: 0,
            upload_total: 0,
            upload_fail: 0,
            showFileList: [],
            name: "fontfile",
            maximum: 20,
            accept: ".otf,.ttf,OTF,TTF",
            extensions: ".otf,.ttf",
            multiple: false,
            directory: false,
            addIndex: false,
            uploadAuto: true,
            uploaddata: null,
            actmode: "add", //默认行为为添加
            acttype: "system", //添加编辑字体默认为系统类型
            editTipTile: "",
            fullscreenLoading: false,
            page: 1,
            pagesize: 20,
            waitEdit: null,
            deleteTip:
                "删除字体后，使用过该字体的文本，将替换为思源黑体-常规，请谨慎操作！",
            deletePosition: "list",
            fontremoveenable: false,
            headers:{}
        };
    },

    computed: {
        fontB() {
            return this.FontsInfo.font_b;
        },
        fontList() {
            return this.FontsInfo.fonts;
        },
        fontT() {
            return this.FontsInfo.font_t;
        },
        loginInfo() {
            return this.$store.getters.loginInfo;
        },
        fontaction() {
            //添加字体调用相应的接口url
            if (this.actmode == "add" || this.actmode == "edit") {
                return `api/brands/fonts/upload`;
            }

            //默认返回 "#"
            return "#";
        },
        fontselectmultiple() {
            //添加字体可以多选
            if (this.actmode == "add") {
                return true;
            }

            //修改字体不可以多选
            if (this.actmode == "edit") {
                return false;
            }

            //预防修改字体默认不可以多选
            return false;
        },
        uploaded() {
            if (this.showFileList.length == 0) {
                return true;
            }
            if (this.$refs.upload && this.$refs.upload.uploaded) {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        this.getFontsOpen();
    },
    mounted() {
        document.addEventListener("click", this.resetChecked, false);
        this.uploaddata = {
            team_id: this.loginInfo.current_team_id,
            // file: this.showFileList,
        };
        let access_token = tokenFunc.getToken();
        if (access_token) {
            this.headers["token"] = `Bearer ${access_token}`;
            this.headers["Authorization"] = `Bearer ${access_token}`;
        }
        // let token = localStorage.authorization ?  JSON.parse(localStorage.authorization) : "";
        // if (token) {
        //     this.headers["token"] = `Bearer ${token.access_token}`;
        //     this.headers["Authorization"] = `Bearer ${token.access_token}`;
        // }
    },
    methods: {
        resetChecked() {
            this.checkFontIndex = 0;
            this.checkedStatus = false;
        },
        checkedFont(index) {
            if (this.checkFontIndex === index) {
                this.checkFontIndex = 0;
                this.selectedFontObj = {};
            } else {
                this.checkFontIndex = index;
                this.checkedStatus = true;
            }
        },

        editFontOpen(act) {
            debugger
            let res = this.expireHandle();
            //actmode 定义是添加动作还是修改动作
            this.actmode = act;
            this.waitEdit = {};
            //acttype定义是爱设计系统字体还是用户自身上传字体
            this.acttype = "system";

            if (res) {
                this.editFontDialogStatus = true;
                //取消下拉内容
                this.checkedStatus = false;
                if (this.checkFontIndex) {
                    if (this.checkFontIndex === 1) {
                        if (this.fontT.hasOwnProperty("id")) {
                            this.selectedFontObj = this.fontT;
                            if (!this.selectedFontObj.hasOwnProperty("attr")) {
                                this.selectedFontObj["attr"] = 3;
                            }
                        } else {
                            /* this.selectedFontObj = this.fontOptions.find((item) => {
                                                  return item.view === this.fontT.view;
                                              }); */
                            this.selectedFontObj = this.fontT;
                            if (!this.selectedFontObj.hasOwnProperty("attr")) {
                                this.selectedFontObj["attr"] = 3;
                            }
                        }
                    } else if (this.checkFontIndex === 2) {
                        if (this.fontB.hasOwnProperty("id")) {
                            this.selectedFontObj = this.fontB;
                            if (!this.selectedFontObj.hasOwnProperty("attr")) {
                                this.selectedFontObj["attr"] = 2;
                            }
                        } else {
                            this.selectedFontObj = this.fontB;
                            if (!this.selectedFontObj.hasOwnProperty("attr")) {
                                this.selectedFontObj["attr"] = 2;
                            }
                        }
                    } else {
                        this.selectedFontObj = this.fontList[this.checkFontIndex - 3];
                        //此处执行一次深拷贝操作  用于替换字体时(替换前和替换后名称展示确认)
                        this.waitEdit = JSON.parse(JSON.stringify(this.selectedFontObj));
                    }
                } else {
                    this.selectedFontObj = this.fontOptions[0];
                }
                //此处执行一次深拷贝操作  用于替换字体时(替换前和替换后名称展示确认)
                this.waitEdit = JSON.parse(JSON.stringify(this.selectedFontObj));
            }
        },
        getFontsOpen() {
            Brand.Fonts().then((res) => {
                this.fontOptions = res.data;
            });
        },
        //修改字体提示确认执行
        editFont() {
            console.log(this.acttype);
            //上传本地字体编辑
            if (this.acttype == "local") {
                //展示上传弹框
                this.uploadLocalVisiable = true;

                //关闭提示弹框
                this.fontEditDialogStatus = false;
            }

            //使用系统字体编辑
            if (this.acttype == "system") {
                let data;
                let _this = this;
                if (this.checkFontIndex === 1) {
                    data = this.fontT;
                    data["attr"] = data.attr ? data.attr : 3;
                } else if (this.checkFontIndex === 2) {
                    data = this.fontB;
                    data["attr"] = data.attr ? data.attr : 2;
                } else {
                    data = {};
                    data["attr"] = data.attr ? data.attr : 1;
                }
                let submitData = {
                    team_id: this.loginInfo.current_team_id,
                    attr: data.attr ? data.attr : 1,
                    sys_font_id: this.selectedFontObj.id,
                };

                if (data.attr == 1) {
                    submitData["font_id"] = this.waitEdit && this.waitEdit.id;
                }
                if (data.attr == 2 || data.attr == 3) {
                    if (data.hasOwnProperty("id")) {
                        submitData["font_id"] = this.waitEdit && this.waitEdit.id;
                    }
                }
                Brand.fontUpload(submitData, "POST").then((res) => {
                    if (res.status === 1) {
                        this.fontClose();
                        this.$message.success("修改成功");
                        this.$emit("pagereset");
                        //this.$emit("getFontData");
                        _this.fontEditDialogStatus = false;
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        selectedFont(item) {
            this.selectedFontObj = item;
            this.fontListStatus = false;
        },
        fontSubmit() {
            let data;
            if (this.checkFontIndex === 1) {
                data = this.fontB;
            } else if (this.checkFontIndex === 2) {
                data = this.fontT;
            } else {
                data = {};
            }
            let submitData = {
                team_id: this.loginInfo.current_team_id,
                sys_font_id: this.selectedFontObj.id,
                attr: data.attr ? data.attr : 1,
            };
            //判断动作是添加或者修改
            //添加
            if (this.actmode == "add") {
                //使用系统字体添加
                // this.actmode
                if (this.acttype == "system") {
                    Brand.fontUpload(submitData, "POST").then((res) => {
                        if (res.status === 1) {
                            this.fontClose();

                            this.$message.success("新增成功");
                            this.$emit("pagereset");
                            //this.$emit("getFontData");
                        }
                    });
                }
            }
        },
        deleteFont() {
            let _this = this;
            this.fontremoveenable = true;
            if (this.deletePosition == "uploader") {
                let data = {
                    font_id: this.deleteFile.response.data.id,
                };

                Brand.Fonts(data, "DELETE")
                    .then((res) => {
                        this.fontremoveenable = false;
                        if (res.status === 1) {
                            _this.$refs.upload.remove(_this.deleteFile);
                            _this.removeDialogStatus = false;
                            Vue.prototype.$message.success("删除成功");
                            _this.deletePosition = "list";
                            _this.resetChecked();
                        }
                    })
                    .catch((error) => {
                        this.fontremoveenable = false;
                    });
            } else {
                let data = {
                    font_id: this.fontList[this.checkFontIndex - 3].id,
                };

                Brand.fontsRemove(data)
                    .then((res) => {
                        this.fontremoveenable = false;
                        if (res.status === 1) {
                            Vue.prototype.$message.success("删除成功");
                            this.fontClose();
                            this.$emit("pagereset");
                            //this.$emit("getFontData");
                            this.resetChecked();
                        }
                    })
                    .catch((error) => {
                        this.fontremoveenable = false;
                    });
            }
        },
        showRemoveDialog() {
            let _this = this;
            this.deleteTip =
                "删除字体后，使用过该字体的文本，将替换为思源黑体-常规，请谨慎操作！";
            this.removeDialogStatus = true;
            this.checkedStatus = false;
        },
        fontClose() {
            /* 	this.selectedFontObj = {};
                      this.checkFontIndex = 0; */
            this.editFontDialogStatus = false;
            this.removeDialogStatus = false;
            this.fontListStatus = false;
        },
        close() {
            this.fontClose();
        },
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // 添加文件
                if (!/\.(ttf|otf|TTF|OTF)$/i.test(newFile.name)) {
                    //上传失败提醒数量统计
                    this.upload_fail++;
                    return prevent();
                }

                newFile.upload_step = 1;
                newFile.upload_status = 0;
            }

            // 更新文件
            if (newFile && oldFile) {
                // 开始上传
                if (newFile.active !== oldFile.active) {
                    console.log("Start upload");

                    //2为上传中
                    newFile.upload_step = 2;
                }

                // 上传进度
                if (newFile.progress !== oldFile.progress) {
                    newFile.upload_status = 2;
                    newFile.upload_step = 2;
                }

                // 上传错误  这种情况一般是接口出错
                if (newFile.error !== oldFile.error) {
                    newFile.upload_status = 5;

                    //3为上传结束

                    newFile.upload_step = 3;
                    newFile.maskshow = false;
                }

                // 上传成功  根据接口实际情况来判断
                if (newFile.success !== oldFile.success) {
                    //接口的status为1  实际为成功
                    if (newFile.success && newFile.response.status == 1) {
                        newFile.upload_status = 4;
                        newFile.upload_step = 3;
                    }
                    //接口的status为0 实际为失败
                    if (newFile.success && newFile.response.status == 0) {
                        newFile.upload_status = 3;
                        newFile.upload_step = 3;
                        newFile.maskshow = false;
                        this.upload_fail++;

                        // Vue.prototype.$zmessage.error({
                        //     message: `${newFile.name.split(".")[0]}${newFile.response.error || newFile.response.message}`,
                        //     duration: 2000,
                        //     customClass: "zmessage-tip",
                        // });
                    }
                    //3为上传结束

                    console.log("success");
                }
            }
        },

        // add, update, remove File Event
        inputFile(newFile, oldFile) {
            if (newFile && !oldFile) {
                this.showuploadtool = false;
                // 添加文件
                newFile.upload_status = 0;

                //1为等待上传
                newFile.upload_step = 1;
            }

            // 更新文件
            if (newFile && oldFile) {
                // 开始上传
                if (newFile.active !== oldFile.active) {
                    console.log("Start upload");

                    //2为上传中
                    newFile.upload_step = 2;
                }

                // 上传进度
                if (newFile.progress !== oldFile.progress) {
                    newFile.upload_status = 2;
                    newFile.upload_step = 2;
                }

                // 上传错误  这种情况一般是接口出错
                if (newFile.error !== oldFile.error) {
                    newFile.upload_status = 5;

                    //3为上传结束

                    newFile.upload_step = 3;
                    newFile.maskshow = false;
                }

                // 上传成功  根据接口实际情况来判断
                if (newFile.success !== oldFile.success) {
                    //接口的status为1  实际为成功
                    if (newFile.success && newFile.response.status == 1) {
                        newFile.upload_status = 4;
                        newFile.upload_step = 3;
                    }
                    //接口的status为0 实际为失败
                    if (newFile.success && newFile.response.status == 0) {
                        newFile.upload_status = 3;
                        newFile.upload_step = 3;
                        newFile.maskshow = false;
                        //Vue.prototype.$message.error(response.error);
                    }
                    //3为上传结束

                    console.log("success");
                }
            }

            if (!newFile && oldFile) {
                if (this.showFileList.length == 0) {
                    this.showuploadtool = true;
                }
            }

            // 自动上传
            if (
                Boolean(newFile) !== Boolean(oldFile) ||
                oldFile.error !== newFile.error
            ) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                    this.$refs.upload.active = true;
                }
            }
        },
        inputUpload(value) {
            if (value.length == 0) {
                this.showuploadtool = true;
            }
        },
        exceed() {
            Vue.prototype.$message.error(`本地上传单次最多上传${this.maximum}个字体`);
        },
        fontmouseover(file, index) {
            file.maskshow = true;
            this.$set(this.showFileList, index, file);
        },
        fontmouseout(file, index) {
            file.maskshow = false;
            this.$set(this.showFileList, index, file);
        },
        stopUpload() {
            let _this = this;
            if (this.showFileList.length > 0) {
                this.showFileList.forEach((value, index) => {
                    //停止上传请求并删除对应文件
                    _this.$refs.upload.update(value, { error: "abort" });
                });
                _this.$refs.upload.clear();
                this.$emit("pagereset");
                //this.$emit("getFontData");
            }
            //上传失败数量重置为0
            this.upload_fail = 0;

            //关闭提示弹框
            this.uploadCancelDialogStatus = false;

            //关闭上传弹框
            this.uploadLocalVisiable = false;
        },
        removeLocalFont(file) {
            let _this = this;
            if (file.success && file.response.status == 1) {
                let data = {
                    font_id: file.response.data.id,
                };
                //判断是否是最后一个品牌字体
                /* if(this.fontList.length <=1){
                                this.deleteTip = "删除后，工作台将展示默认字体，确认删除吗？";
                                this.deleteFile = file;
                            	
                                //从上传视图删除
                                this.deletePosition = 'uploader';
                                this.removeDialogStatus = true;
                            	
                            }else{
                        	
                            } */
                Brand.Fonts(data, "DELETE")
                    .then((res) => {
                        if (res.status == 1) {
                            _this.$refs.upload.remove(file);
                            Vue.prototype.$message.success("删除成功");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        openUploadLocal() {
            //更新操作方式为本地
            this.acttype = "local";
            this.editFontDialogStatus = false;

            //添加字体
            if (this.actmode == "add") {
                this.uploadLocalVisiable = true;
                this.uploaddata = {
                    team_id: this.loginInfo.current_team_id,
                    attr: 1
                    // file: this.showFileList,
                };
            }

            //修改字体  需要传入字体对应的font_id
            if (this.actmode == "edit") {
                //展示提示弹框

                this.fontEditDialogStatus = true;
                this.checkedStatus = false;
                this.editTipTile = `修改成功后，使用过该字体的模板将更新为修改后的字体`;
                this.uploaddata = {
                    team_id: this.loginInfo.current_team_id,
                    //file: this.showFileList,
                    attr: this.waitEdit ? this.waitEdit.attr : 1,
                };
                if (this.waitEdit.hasOwnProperty("id")) {
                    //this.$set(this.uplodadata,"font_id",this.waitEdit.id)

                    this.uploaddata["font_id"] = this.waitEdit.id;
                }
            }
        },
        selectSystemConfirm(editType) {
            //添加字体  不做确认提示
            if (this.actmode == "add") {
                this.fontSubmit("add");
            }

            //编辑字体   需要做确认提示
            if (this.actmode == "edit") {
                if (this.waitEdit.name == this.selectedFontObj.name) {
                    this.editFontDialogStatus = false;
                    return;
                }
                this.fontEditDialogStatus = true;
                this.checkedStatus = false;
                //关闭选择字体框前先记录当前选择的系统字体信息

                this.editFontDialogStatus = false;

                let editNameBefore = this.waitEdit.name;
                let editNameAfter = this.selectedFontObj.name;
                //this.editTipTile = `使用过“${editNameBefore}”字体的模板，将被替换为“${editNameAfter}”确认修改吗？`;
                this.editTipTile = `修改成功后，使用过该字体的模板将更新为修改后的字体`;
            }
        },
        setLocalVisiableHandler() {
            let _this = this;
            //loading
            this.fullscreenLoading = true;

            Brand.getType(
                {
                    team_id: _this.loginInfo.current_team_id,
                }
            )
                .then((res) => {
                    if (res.status == 1) {
                        _this.fullscreenLoading = false;
                        _this.checkList = res.data;
                        _this.setLocalVisiable = true;
                    }
                })
                .catch((err) => {
                    _this.fullscreenLoading = false;
                });

            //获取当前设置的字体显示状态进行回显
        },
        uploadLocalconfirm() {
            this.uploadLocalVisiable = false;
            if (this.showFileList.length > 0) {
                var isTip = false;
                this.showFileList.forEach((value, index) => {
                    if (value.success && value.upload_status == 4) {
                        isTip = true;
                    }
                });

                if (isTip) {
                    Vue.prototype.$message.success("上传成功");
                }
            }
        },
        uploadLocalcancle() {
            //this.uploadLocalVisiable = false;
            //this.$refs.uploadfontdialog.close();
            if (this.showFileList.length == 0) {
                this.uploadLocalVisiable = false;
            }

            if (this.showFileList.length > 0) {
                var isTip = false;
                this.showFileList.forEach((value, index) => {
                    if (
                        (!value.active && !value.success) ||
                        value.progress != "0.00" ||
                        value.upload_step == 1 ||
                        value.upload_step == 2
                    ) {
                        isTip = true;
                    }
                });

                if (isTip) {
                    //取消后未成功的需要重新上传，是否取消？
                    this.uploadCancelDialogStatus = true;
                }
            }
        },
        uploadbeforeclose(done) {
            //判断当前是否有上传内容
            if (this.showFileList.length == 0) {
                done();
            }

            if (this.showFileList.length > 0) {
                var isTip = false;
                this.showFileList.forEach((value, index) => {
                    if (
                        (!value.active && !value.success) ||
                        value.progress != "0.00" ||
                        value.upload_step == 1 ||
                        value.upload_step == 2
                    ) {
                        isTip = true;
                    }
                });

                if (isTip) {
                    //取消后未成功的需要重新上传，是否取消？
                    this.uploadCancelDialogStatus = true;
                    return false;
                }
            }
        },
        openuploadtool() {
            this.showuploadtool = true;
            this.showFileList = [];
        },
    },
    beforeDestroy() {
        document.addEventListener("click", null);
    },
    watch: {
        showFileList(list, oldList) {
            this.upload_total = list.length;
            this.upload_finished = list.filter((item) => {
                return item.upload_step == 3 || item.upload_step == 4;
            }).length;
        },
    },
};
</script>
<style lang="scss">
.zmessage-tip {
    z-index: 9000 !important;
}
</style>
<style lang="scss" scoped>
.brand-font {
    .setup-btn {
        font-size: 16px;
        color: #aaaab1;
        padding-left: 8px;
        &:hover {
            color: $activeColor;
        }
    }
    ul {
        padding-bottom: 70px;
    }
    li {
        margin-bottom: 20px;

        &.font-li {
            width: 260px;
            background: #fff;
            border-radius: 8px;
            border: 1px solid #e7e7e7;
            box-sizing: border-box;
            position: relative;
            transition: all 0.3s;
            .font-icon-more {
                display: none;
            }

            &:hover {
                background: $hoverColor;

                .font-icon-more {
                    display: block;
                }
            }

            .font-title {
                height: 84px;
                border-bottom: 1px solid #e1e1e1;
                box-sizing: border-box;
                line-height: 83px;
                padding-left: 16px;
                font-size: 33px;
                color: #000;
                img {
                    max-width: 230px;
                    height: 30px;
                }
            }

            .font-name {
                height: 34px;
                padding-left: 16px;
                padding-right: 16px;
                display: flex;
                justify-content: space-between;
                line-height: 34px;

                .font-name-text {
                    font-size: 14px;
                    font-weight: 400;
                    color: #3c3c43;
                    line-height: 34px;
                    @include text-ellipsis();
                }
            }

            .font-action {
                width: 160px;
                background: #fff;
                box-shadow: 0px 0px 20px 0px rgba(175, 175, 175, 0.44);
                border-radius: 8px;
                text-align: center;
                padding: 0 5px;
                border: none;
                box-sizing: border-box;
                position: absolute;
                top: 120px;
                left: 220px;
                z-index: 99;
                margin-bottom: 10px;

                p {
                    line-height: 44px;
                    height: 45px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #424244;
                    border-bottom: 1px solid #e7e7e7;
                    box-sizing: border-box;
                    cursor: pointer;

                    &:hover {
                        color: $activeColor;
                    }
                }
            }
        }

        &:nth-child(2) {
            .font-title {
                font-family: "思源黑体-粗体";
                font-weight: 600;
            }
        }

        &:nth-child(3) {
            .font-title {
                font-family: "思源黑体-常规";
            }
        }
    }
}

.font-dialog-con {
    position: relative;

    .selected-font-input {
        @include wh(268px, 40px);
        background: #fff;
        border-radius: 8px;
        border: 1px solid #e1e1e1;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        padding: 0 16px;
    }

    .font-list {
        position: absolute;
        top: 0px;
        left: 0;
        @include wh(268px, 190px);
        border: 1px solid #e1e1e1;
        border-radius: 5px;
        background: #fff;
    }

    li {
        @include wh(100%, 34px);
        line-height: 34px;
        padding: 3px 10px;
        margin-right: 0;

        &:hover,
        &.active {
            background: #e1e1e1;
        }
    }

    .upload-loclbtn {
        width: 268px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3c3c43;
        line-height: 20px;
        margin-top: 16px;
        margin: 16px auto 112px;
        padding: 0 16px;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        .upload-btnbox {
            width: 110px;
            span.iconfont {
                color: #aaaab1;
                padding-right: 6px;
            }
            &:hover {
                color: #5a2df5;
                span.iconfont {
                    color: #5a2df5;
                }
            }
        }
    }
}

::v-deep( .upload-localfont-dialog) {
    @include dialog-525(744px, 610px, 80px);
    .el-dialog__body {
        height: 440px;
        padding: 0 40px;
        overflow-y: auto;
        overflow-x: hidden;
        @include prefixer(box-sizing, border-box);
        .upload-localfont-title {
            span {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3c3c43;
                line-height: 22px;
            }
        }

        .errorinfo-alert {
            height: 32px;
            padding: 6px 12px;
            margin-top: 8px;
            background: rgba(229, 75, 75, 0.1);
            @include prefixer(box-sizing, border-box);

            .el-alert__content {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3c3c43;
            }
        }

        #upload-section {
            @include flexble();
            width: 100%;
            height: 120px;
            cursor: pointer;
            .upload-component {
                @include flexble();
                .el-upload,
                .el-upload--picture-card {
                    width: 120px;
                    height: 120px;
                    line-height: 120px;
                    background: #f3f3f3;
                    border-radius: 6px;
                    border: none;
                    @include flex();
                    @include justify-content(center);
                    @include align-item(center);
                    i {
                        font-size: 44px;
                        color: #aaaab1;
                    }
                }
                .el-upload-list,
                .el-upload-list--picture-card {
                    @include flex();
                    @include flex-wrap(wrap);
                    .el-upload-list__item {
                        width: 120px;
                        height: 120px;
                        border: 1px solid #e7e7e7;
                        margin: 0;
                        padding: 0;
                        margin-left: 16px;
                    }
                }
            }

            i {
                font-size: 44px;
                color: #aaaab1;
            }
        }

        .upload-list-box {
            margin-top: 18px;
            @include flexble();
            @include flex-wrap(wrap);
            li {
                width: 120px;
                height: 147px;
                position: relative;
                margin-right: 16px;
                margin-bottom: 16px;
                cursor: default;
                .state-box {
                    position: relative;
                    width: 120px;
                    height: 120px;
                    /*  background: rgba(0,0,0,.6); */

                    @include prefixer(box-sizing, border-box);
                    @include prefixer(border-radius, 6px);
                    @include flexble();
                    @include justify-content(center);
                    @include align-item(center);
                    img {
                        width: 36px;
                        height: 44px;
                    }
                    img.img_path {
                        width: 100%;
                        height: 100%;
                    }
                }

                .upload-listitem-actions {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    cursor: default;
                    text-align: center;
                    font-size: 6px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 9px;
                    background-color: rgba(0, 0, 0, 0.6);
                    @include prefixer(border-radius, 6px);
                    @include flexble();
                    @include justify-content(center);
                    @include align-item(center);
                    .el-progress {
                        width: 80px;

                        .el-progress-bar {
                            padding-right: 0;
                            margin-right: 0;
                            .el-progress-bar__outer {
                                background-color: #b2b2b2;
                            }
                        }
                    }

                    .tryagain-btn {
                        &.el-button {
                            border-radius: 6px;
                            line-height: 16px;
                            border: 1px solid #fff;
                            color: #fff;
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            background-color: transparent;
                            padding: 3px 15px;
                        }
                    }

                    .upload-fail-icon {
                        width: 16px;
                        height: 16px;
                        margin-bottom: 7px;
                    }
                    .upload-delete-icon {
                        width: 18px;
                        height: 18px;
                        cursor: pointer;
                        position: absolute;
                        top: -9px;
                        right: -9px;
                    }
                    .upload-fail-tiptext {
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: #ffffff;
                        line-height: 16px;
                    }

                    &.upload-listitem-actions-tip {
                        @include flex-direction(column);
                    }
                }
                .state-box-border {
                    border: 1px solid #e7e7e7;
                }
                .upload-lsititem-title {
                    margin-top: 8px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3c3c43;
                    line-height: 17px;
                    @include text-ellipsis();
                }
            }
            .fileitem:nth-of-type(5n + 1) {
                margin-right: 0;
            }
        }
    }

    .el-dialog__footer {
        padding: 0;
        .btn-wrap {
            @include justify-content(center);
            button {
                width: 110px;
                height: 40px;
                margin-right: 48px;
                &:nth-last-of-type(1) {
                    margin-right: 0;
                }
            }
        }
    }
}

::v-deep(.file-uploads) {
    width: 120px;
    height: 120px;
    background: #f3f3f3;
    border-radius: 6px;
    cursor: pointer;
    @include prefixer(box-sizing, border-box);
    @include flexble();
    @include justify-content(center);
    @include align-item(center);

    &.file-uploads-html5 label {
        cursor: pointer;
    }
}

::v-deep( .setvisiable-dialog) {
    @include dialog-525(364px, 328px, 80px);
    -webkit-font-smoothing: subpixel-antialiased;
    .el-dialog__body {
        @mixin checktext() {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3c3c43;
            line-height: 20px;
            -webkit-font-smoothing: subpixel-antialiased;
        }
        .check-visiable-content {
            padding-left: 48px;
            margin-bottom: 16px;
            .check-visiable-title {
                @include checktext();
            }

            .check-list {
                margin-top: 18px;
                .check-item {
                    height: 20px;
                    margin-bottom: 20px;
                    &:nth-last-of-type(1) {
                        margin-bottom: 52px;
                    }
                    .el-checkbox {
                        @include checktext();
                        .el-checkbox__input {
                            .el-checkbox__inner {
                                width: 16px;
                                height: 16px;
                                background: #ffffff;

                                border-radius: 2px;
                                border: 1px solid #aaaab1;
                                @include prefixer(border-radius, 2px);
                            }

                            &.is-checked {
                                .el-checkbox__inner {
                                    background: #5a2df5;
                                    border: 1px solid #5a2df5;
                                    &::after {
                                        border: 2px solid #fff;
                                        box-sizing: content-box;
                                        content: "";
                                        border-left: 0;
                                        border-top: 0;
                                        height: 7px;
                                        left: 4px;
                                        position: absolute;
                                        top: 2px;
                                    }
                                }
                            }

                            &.is-checked + .el-checkbox__label {
                                color: #3c3c43;
                            }
                        }

                        .el-checkbox__label {
                            padding-left: 8px;
                            line-height: 20px;
                            @include checktext();
                        }
                    }
                }
            }
        }
    }

    .el-dialog__footer {
        padding: 0;
        .btn-wrap {
            @include justify-content(center);
            button {
                width: 110px;
                height: 40px;
                margin-right: 48px;
                -webkit-font-smoothing: subpixel-antialiased;
                &:nth-last-of-type(1) {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
